import ConnectedAnalysisList from './Container';

export default ConnectedAnalysisList;
